import "./btn.css"

const Btn = (props) => {

    const {type, onClick, text, className} = props
    return (
        <button className={className} type={type} onClick={onClick}>{text}</button>

    )
}
export default Btn